export const GuidelineExpanderCardTestIds = {
  READ_FULL_SECTION_BUTTON: 'guideline-card.read-full-section-button',
  ASK_ABOUT_GUIDELINE_BUTTON: 'guideline-card.ask-about-guideline-button',
  UNAVAILABLE: 'guideline-card.unavailable',
};
